export function isAnyStringFieldValid<T extends Record<string, unknown>>(
  obj: T
): boolean {
  return Object.values(obj).some(
    (value) => typeof value === "string" && value.trim().length > 0
  );
}
